import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { shareReplay, finalize } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { ChatRequest, ChatResponse, Conversation, ConversationStarter } from '../models/chat.model';

@Injectable({
  providedIn: 'root'
})
export class ChatService {
  private readonly apiUrl = environment.apiUrl;
  private readonly chatEndpoint = environment.apiEndpoints.chat;

  // Request deduplication map - prevents duplicate API calls from UI glitches/double-clicks
  private activeRequests = new Map<string, Observable<ChatResponse>>();

  constructor(private http: HttpClient) {}

  sendMessage(request: ChatRequest): Observable<ChatResponse> {
    const cacheKey = `${request.datasetId}:${request.message}`;

    // Return existing request if identical one is in-flight
    const existing = this.activeRequests.get(cacheKey);
    if (existing) {
      return existing;
    }

    const request$ = this.http.post<ChatResponse>(
      `${this.apiUrl}/public${this.chatEndpoint}`,
      request
    ).pipe(
      shareReplay(1),
      finalize(() => this.activeRequests.delete(cacheKey))
    );

    this.activeRequests.set(cacheKey, request$);
    return request$;
  }

  getConversationStarters(datasetId: string): Observable<ConversationStarter[]> {
    return this.http.get<ConversationStarter[]>(`${this.apiUrl}${this.chatEndpoint}/starters/${datasetId}`);
  }

  getConversationHistory(sessionId: string): Observable<Conversation> {
    return this.http.get<Conversation>(`${this.apiUrl}${this.chatEndpoint}/history/${sessionId}`);
  }
} 